export default __webpack_public_path__ + "static/media/sentiment_love.8b0451f2.svg";